import React from 'react';
import { StyleSheet, View } from 'react-native';

import { AvatarIcon } from '@components/Avatar';
import { BigButton } from '@components/Button';
import { Logo } from '@components/Image';
import { Paragraph, Subheading } from '@components/Typography';

type PlaceholderProps = Omit<React.ComponentProps<typeof View>, 'children'> & {
  title?: string;
  message?: string;
  icon?: string;
  action?: string;
  onPress?: () => void;
  logo?: boolean;
};

export default function Placeholder({
  title,
  message,
  icon,
  action,
  onPress,
  style,
  logo,
  ...props
}: PlaceholderProps) {
  return (
    <View style={[styles.container, style]} {...props}>
      {logo ? <Logo style={styles.logo} /> : null}
      {icon ? <AvatarIcon icon={icon} style={styles.avatar} /> : null}
      {title ? <Subheading style={styles.text}>{title}</Subheading> : null}
      {message ? <Paragraph style={styles.text}>{message}</Paragraph> : null}
      {action ? (
        <View style={styles.buttonContainer}>
          <BigButton
            mode="contained"
            uppercase={false}
            labelStyle={styles.buttonLabel}
            onPress={onPress}>
            {action}
          </BigButton>
        </View>
      ) : null}
    </View>
  );
}

export function EmptySearchPlaceholder(
  props: Omit<PlaceholderProps, 'icon' | 'message' | 'action'>
) {
  return (
    <Placeholder
      icon="magnify"
      title="No results found"
      message="Please modify your search"
      {...props}
    />
  );
}

const styles = StyleSheet.create({
  avatar: {
    margin: 5,
  },
  buttonContainer: {
    flexShrink: 1,
  },
  buttonLabel: {
    fontWeight: 'normal',
    paddingHorizontal: 5,
  },
  container: {
    alignItems: 'center',
    padding: 20,
  },
  logo: {
    alignSelf: 'center',
    margin: 5,
  },
  text: {
    textAlign: 'center',
  },
});
